import React from "react";
import { PrivacyData } from "./PrivacyData";
import NavBar from "../../components/NavBar/NavBar";
import Pitch from "../../components/Pitch/Pitch";
import Footer from "../../components/Footer/Footer";

const Privacy = () => {
  return (
    <div>
      <NavBar />

      {/* <div className="terms__con">
        <div className="container terms__main">
          <div className="terms__main-header">
            <h3>PRIVACY POLICY</h3>
          </div>

          <div className="terms__main-body">
            {PrivacyData.split('\n').map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div> */}
      <div style={styles.container}>
        <div style={styles.centerBlock}>
          <div style={styles.header}>
            <h3 style={styles.title}>Privacy Policy for MedScroll</h3>
            <p>Last Updated: 8th April, 2025</p>
          </div>
        </div>

        <ul style={styles.list}>
          <li style={styles.li}>
            <span style={styles.bold}>Introduction</span>
            <p style={styles.paragraph}>
              At MedScroll (owned and operated by Loopscribe Pty Ltd), we value
              your privacy and are committed to protecting your personal
              information. This Privacy Policy explains how we collect, use,
              disclose, and secure your data when you use our AI-powered
              learning app, website, and associated services ("Service"). We
              follow the Australian Privacy Act, the EU GDPR, the California
              CCPA, and other applicable laws.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>Information We Collect</span>
            <p style={styles.paragraph}>
              When you sign up or create a user profile, we collect:
            </p>

            <ul style={styles.innerList}>
              <li>
                <span>Required Information:</span>
                <ul style={styles.innerList}>
                  <li>Name</li>
                  <li>Email address</li>
                </ul>
              </li>
              <li>
                <span>Optional Information:</span>
                <ul style={styles.innerList}>
                  <li>
                    Username, role (e.g., doctor, medical student), specialty,
                    subspecialty, location, and profile image
                  </li>
                </ul>
              </li>
              <p style={styles.paragraph}>
                We also collect typical data automatically, such as:
              </p>
              <li>
                <ul style={styles.innerList}>
                  <li>Usage data (how you interact with our Service)</li>
                  <li>
                    Device information (IP address, device type, operating
                    system, browser)
                  </li>
                  <li>General location data based on your IP address</li>
                </ul>
              </li>
            </ul>
            <p style={styles.paragraph}>
              Note: Payment details are handled by external platforms (e.g., app
              stores or Stripe) and are not stored by MedScroll.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>How We Use Your Information</span>
            <p style={styles.paragraph}>We use your personal information to:</p>
            <ul style={styles.innerList}>
              <li>Provide, maintain, and improve our Service</li>
              <li>
                Personalize your experience and tailor content to your interests
              </li>
              <li>Send updates and communications about our Service</li>
              <li>Analyze usage trends using anonymized data</li>
            </ul>
            <p style={styles.paragraph}>
              For content you share on MedScroll, your chosen privacy settings
              determine who can access it. We use anonymized, aggregated data
              from public interactions to enhance personalization—but we do not
              use your private data to train our AI models.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>Ownership of Content</span>
            <ul style={styles.innerList}>
              <li>
                <span>
                  <span style={styles.bold}>User-Generated Content:</span> You
                  own the content you create and share on our platform.
                </span>
              </li>
              <li>
                <span>
                  <span style={styles.bold}>AI-Generated Content:</span> Content
                  generated by our AI as part of our service remains the
                  property of MedScroll, provided solely for your personal and
                  educational use.
                </span>
              </li>
              <li>
                <span>
                  Your privacy settings control who sees your shared content on
                  MedScroll.
                </span>
              </li>
            </ul>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>Disclosure to Third Parties</span>
            <p style={styles.paragraph}>
              We share your information only with trusted third-party service
              providers necessary to operate our Service. These include:
            </p>
            <ul style={styles.innerList}>
              <li>
                <span>
                  <span style={styles.bold}>OpenAI:</span> Provides AI models
                  and services that support our interactive learning features.
                </span>
              </li>
              <li>
                <span>
                  <span style={styles.bold}>GroqAI:</span> Offers AI processing
                  capabilities to enhance the performance of our applications.
                  use.
                </span>
              </li>
              <li>
                <span>
                  <span style={styles.bold}>ElevenLabs:</span> Delivers advanced
                  voice synthesis and audio services to support multimedia
                  content.
                </span>
              </li>
              <li>
                <span>
                  <span style={styles.bold}>MongoDB:</span> Manages our
                  databases securely, ensuring your data is stored efficiently.
                </span>
              </li>
              <li>
                <span>
                  <span style={styles.bold}>Amplitude:</span> Facilitates
                  analytics to help us analyze usage trends and improve the
                  Service.
                </span>
              </li>
            </ul>
            <p style={styles.paragraph}>
              These partners are contractually obligated to use your information
              solely to support the Service and must follow applicable data
              protection laws.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>Data Security and Storage</span>
            <p style={styles.paragraph}>
              Your data is stored on secure cloud services with robust security
              measures like encryption and strict access controls. While no
              method is entirely risk-free, we take all reasonable steps to
              protect your information.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>User Rights and Choices</span>
            <p style={styles.paragraph}>
              Depending on your location, you may have rights regarding your
              personal data, such as the right to access, correct, or delete
              your information. For example:
            </p>
            <ul className="mt-2 flex flex-col gap-3 list-disc list-inside px-2 md:px-5">
              <li>
                <span>
                  <span style={styles.bold}>Under GDPR:</span> You have the
                  right to access, rectify, erase, restrict, port, or object to
                  processing of your data.
                </span>
              </li>
              <li>
                <span>
                  <span style={styles.bold}>Under CCPA:</span> You have the
                  right to request details about the personal data we collect,
                  request deletion, and opt out of any future sale (note: we do
                  not sell personal data).
                </span>
              </li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at
              <span style={styles.bold}>hello@loopscribe.com</span>.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>Data Retention</span>
            <p style={styles.paragraph}>
              We retain your personal information as long as you are a
              registered user. If you delete your account, certain information
              may be retained for up to 90 days before being permanently
              removed.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>{"Minors' Privacy"}</span>
            <p style={styles.paragraph}>
              Our Service is intended for users 16 years and older. If a user
              under 16 uses our Service, their parent or legal guardian must
              provide consent and supervise their use. If we learn that a minor
              has provided personal information without proper consent, we will
              promptly remove that information.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>International Data Transfers</span>
            <p style={styles.paragraph}>
              Your information may be stored and processed in countries other
              than your own. We ensure that these transfers comply with the
              Australian Privacy Act, GDPR, CCPA, and related laws, using
              appropriate safeguards.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>Cookies and Tracking Technologies</span>
            <p style={styles.paragraph}>
              We use cookies and similar technologies to enhance your
              experience, analyze trends, and serve targeted content. You can
              manage your preferences through your browser settings.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>
              Simplified Disclosures for GDPR and CCPA
            </span>
            <ul className="mt-2 flex flex-col gap-3 list-disc list-inside px-2 md:px-5">
              <li>
                <span>
                  <span>GDPR:</span> For EU residents, you have the right to
                  access, correct, delete, restrict, or port your data, and to
                  object to its processing.
                </span>
              </li>
              <li>
                <span>
                  <span>CCPA:</span> For Californian residents, you have the
                  right to request details on the personal information we
                  collect, request deletion, and opt out of any future sale of
                  your data (which we do not engage in).
                </span>
              </li>
            </ul>
            <p style={styles.paragraph}>
              To exercise these rights, contact us at{" "}
              <span style={styles.bold}>hello@loopscribe.com</span>.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>Updates to This Privacy Policy</span>
            <p style={styles.paragraph}>
              We may update this Privacy Policy from time to time. The revised
              version will be posted on our website, and your continued use of
              our Service means you accept the updated policy.
            </p>
          </li>

          <li style={styles.li}>
            <span style={styles.bold}>Contact Information</span>
            <p style={styles.paragraph}>
              If you have any questions or concerns about this Privacy Policy or
              our handling of your information, please contact us at:
            </p>
          </li>
          <div>
            <p>
              <span style={styles.bold}>Email:</span> hello@loopscribe.com
            </p>
            <p>
              <span style={styles.bold}>Address:</span> Level 1/390 St Kilda
              Road, Melbourne VIC 3004, Australia
            </p>
          </div>
        </ul>
      </div>

      <Pitch />
      <Footer />
    </div>
  );
};

export default Privacy;

const styles: any = {
  container: {
    backgroundColor: "white",
    color: "black",
    display: "flex",
    flexDirection: "column",
    gap: "2.5rem",
    padding: "1.25rem",
    fontFamily: "Arial, sans-serif",
    fontSize: "14px",
    lineHeight: "1.6",
  },
  centerBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "2.5rem",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  header: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: "0.5rem",
  },
  title: {
    fontSize: "30px",
    fontWeight: "600",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    paddingBottom: "5rem",
    paddingLeft: "1.25rem",
    paddingRight: "1.25rem",
    listStyleType: "decimal",
  },
  li: {
    marginBottom: "1rem",
  },
  innerList: {
    marginTop: "0.5rem",
    paddingLeft: "1.5rem",
    listStyleType: "disc",
    display: "flex",
    flexDirection: "column",
    gap: "0.75rem",
  },
  paragraph: {
    marginTop: "0.5rem",
  },
  bold: {
    fontWeight: "600",
  },
};
